import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const formatValue = (value) => {
  if (Array.isArray(value)) {
    return value.join(",");
  }
  if (value === true) {
    return <span className="bool-true">true</span>;
  }
  if (value === false) {
    return <span className="bool-false">false</span>;
  }
  if (value == null || value === "") {
    return "—";
  }
  return String(value);
};

const ApiFormRecordTable = ({ record, fields }) => {
  const { t } = useTranslation("common");
  const entries = Object.entries(record || {});

  if (entries.length === 0) {
    return <div className="api-form-empty">{t("Select a record to view its data")}</div>;
  }

  return (
    <div className="record-table-wrap">
      <table className="record-table">
        <tbody>
          {entries.map(([name, value]) => (
            <tr key={name}>
              <td>{fields?.[name]?.string || name}</td>
              <td>
                {Array.isArray(value) ? (
                  <span className="link-value">{formatValue(value)}</span>
                ) : (
                  formatValue(value)
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ApiFormRecordTable.propTypes = {
  record: PropTypes.object,
  fields: PropTypes.object
};

ApiFormRecordTable.defaultProps = {
  record: {},
  fields: {}
};

export default ApiFormRecordTable;
